import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import React, { FC } from "react";
import Zone from "@insite/client-framework/Components/Zone";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const ADIAddToCartWrapper: FC<Props> = ({ id }) => {
    return (
        <Hidden
            above="md"
            css={css`
                padding: 20px;
                margin: 20px;
                div[class^="Wrapper"] {
                    display: flex;
                    flex-direction: column;
                    gap: 27px;
                }
            `}
        >
            <Zone contentId={id} zoneName="Content1" />
        </Hidden>
    );
};

const widgetModule: WidgetModule = {
    component: ADIAddToCartWrapper,
    definition: {
        displayName: "ADI PDP Add To Cart",
        group: "Common",
    },
};

export default widgetModule;
